import { getFunctionBaseUrl } from './RestUrls';
import * as rest from './RestUtil';

export interface ITrafficLightsMessage {
  errorID: number;
  value: string;
  name: string;
}

export interface ITrafficLightData {
  type: string;
  color: string;
  msg: ITrafficLightsMessage;
}

export const getTrafficLightsData = async (reportType: string, type: string, period: string) => {
  const url = `${getFunctionBaseUrl()}/api/trafficLights/${reportType}/${type}/${period}`;
  const response = await rest.get(url);
  let lights = [] as ITrafficLightData[];
  if(response)
    lights = response.trafficlights;
  return lights;
}